import { render, staticRenderFns } from "./EfficiencyTable.vue?vue&type=template&id=01d1b9aa&scoped=true&"
import script from "./EfficiencyTable.vue?vue&type=script&lang=js&"
export * from "./EfficiencyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1b9aa",
  null
  
)

export default component.exports